import React from 'react';
import { Box, Typography } from '@mui/material';
import getTextTruncationSx from '../../../../../utils/getTextTruncationSx';

interface ArtifactCardTitleProps {
  title: string;
}

const ArtifactCardTitle: React.FC<ArtifactCardTitleProps> = ({ title }) => (
  <Box sx={{ ...getTextTruncationSx(1) }}>
    <Typography noWrap variant='subtitle3' color='text.primary'>
      {title}
    </Typography>
  </Box>
);

export default ArtifactCardTitle;
